export default class DisplayHelper {
    static toggleButtonColor( raceButtonTint, text1Tint, text2Tint, raceButton, raceButtonText1, raceButtonText2) {
            raceButton.setTint(raceButtonTint);
            raceButtonText1.setColor(text1Tint);
            raceButtonText2.setColor(text2Tint);
    }
}